import React from 'react';
import { Link } from 'react-router-dom';
import '../../css/home/Services.css';

const Services = () => {
  const services = [
    {
      title: "Ambassador Programs",
      description: "We recruit, train, and manage student reps to build awareness and drive conversions.",
      disclaimer: "Our campus networks span 145+ universities with 2,500+ vetted students.",
      color: "#FFA500"
    },
    {
      title: "Influencer & Creator Campaigns",
      description: "Tap into real students creating authentic content for your brand.",
      disclaimer: "Authentic UGC from students who genuinely love your products.",
      color: "#007bff"
    },
    {
      title: "Campus Research & Surveys",
      description: "Understand the student mindset with targeted surveys and behavioral studies.",
      disclaimer: "Data-driven insights to optimize your campus marketing strategy.",
      color: "#ffc300"
    }
  ];

  return (
    <section className="services-section">
      <div className="services-container">
        {services.map((service, index) => (
          <div className="service-card" key={index}>
            <div 
              className="service-image-placeholder" 
              style={{ backgroundColor: service.color }}
            ></div>
            <h2 className="service-title">{service.title}</h2>
            <p className="service-description">{service.description}</p>
            <p className="service-disclaimer">{service.disclaimer}</p>
            <Link to="/brands"><button className="service-button">Learn More</button></Link>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Services;